import React from 'react';
import { router } from './router';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { antTheme } from './helpers/ant-theme';

import './index.css';
import { AuthProvider } from 'context/auth-context';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <ConfigProvider theme={antTheme}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <React.StrictMode>
            <RouterProvider router={router} />
          </React.StrictMode>
        </QueryClientProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}
